import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';

function Settings({ message, handleProtected }) {
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5011';;

  useEffect(() => {
    const fetchSettings = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${backendUrl}/api/settings`, { credentials: 'include' });
        if (response.ok) {
          const data = await response.json();
          setSettings(data);
        } else {
          console.error('Error fetching settings:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSettings();
  }, [backendUrl]);

  const handleSettingChange = (event) => {
    setSettings({ ...settings, [event.target.name]: event.target.value });
  };

  const handleSaveSettings = async () => {
    setIsSaving(true);
    try {
      const response = await fetch(`${backendUrl}/api/settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settings),
        credentials: 'include',
      });
      if (response.ok) {
        console.log('Settings saved successfully');
      } else {
        console.error('Error saving settings:', response.statusText);
      }
    } catch (error) {
      console.error('Error saving settings:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="body1" gutterBottom>
        Individual User Settings
      </Typography>

      <Box mt={2}>
        <Typography variant="h6">Outline Wiki - API Key</Typography>
        <Typography variant="body2" gutterBottom>
          <Link href="https://wiki.atlantic-ventures.com/settings/api-and-access" target="_blank" rel="noopener">
            Generate your API Key here.
          </Link>
          {' | '}
          <Link href="https://wiki.atlantic-ventures.com/doc/federated-search-B3pkaAvdb8" target="_blank" rel="noopener">
            Additional Instructions
          </Link>
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <TextField
              label="Outline API-Key"
              name="outlineApiKey"
              value={settings.outlineApiKey || ''}
              onChange={handleSettingChange}
              fullWidth
              margin="normal"
            />
            <Button variant="contained" onClick={handleSaveSettings} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Settings'}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}

export default Settings;
